import * as types from '../constants/actionTypes';

export function setLocale(locale) {
    return {
        type: types.SET_LOCALE,
        locale
    };
}


// WEBPACK FOOTER //
// ./src/actions/intlActions.js